import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { UserProvider } from './contexts/UserContext';
render(<UserProvider data-id="element-6743">
    <App data-id="element-6744" />
  </UserProvider>, document.getElementById('root'));